enum Actions {
  GET_ALL_TENANTS = 'retrieveAllTenant',
  SEARCH_TENANT = 'searchTenant',
  FETCH_TENANT = 'fetchTenant',
  FIND_EXISTING_TENANT = 'findExistingTenant',
  FIND_EXISTING_TENANT_BY_ID = 'findExistingTenantById',
  FETCH_TENANT_REFERENCES = 'fetchTenantReferences',
}

enum Mutations {
  SET_SEARCH_TENANT_LIST = 'setSearchTenantList',
  SET_ALL_TENANTS = 'setAllTenants',
  SET_TENANT = 'setTenant',
  SET_EXISTING_TENANT = 'setExistingTenant',
  SET_TENANTS = 'setTenants',
  SET_TENANT_LIST_ERROR = 'setTenantListError',
  SET_SEARCH_TENANT_ACTION_ERROR = 'setSearchTenantActionError',
  SET_TENANT_LIST_LOADING = 'setTenantListLoading',
  SET_TENANT_LOADING = 'setTenantLoading',
  SET_TENANT_REFERENCES = 'setTenantReferences',
}

enum Getters {
  GET_SEARCH_TENANT_LIST = 'getSearchTenantList',
  GET_ALL_TENANTS = 'getAllTenants',
  GET_TENANTS = 'getTenants',
  GET_TENANT = 'getTenant',
  GET_EXISTING_TENANT = 'getExistingTenant',
  GET_SEARCH_TENANT_ACTION_ERROR = 'getSearchTenantActionError',
  GET_TENANT_ACTION_ERROR = 'getTenantActionError',
  GET_TENANT_LIST_ERROR = 'getTenantListError',
  GET_TENANT_LIST_LOADING = 'getTenantListLoading',
  GET_TENANT_LOADING = 'getTenantLoading',
  GET_TENANT_REFERENCES = 'getTenantReferences',
}

export { Actions, Mutations, Getters };
